'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BannerText = renderWithRef('BannerText', null, (t, n)=>{
    let { children: o } = t;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        classNames: [
            'swan-banner-text'
        ],
        props: t,
        children: o
    });
});

export { BannerText };
